import {Dispatch} from '@reduxjs/toolkit';
import {setTemplateMeta, setTemplateMapping, setOriginalMapping} from '../templateMapping.slice';
import {DPMeta, DPLayerMapping} from 'common/src/modules/dynamicParameters/dynamicParameters.types';
import {CreativeTemplatePageState} from '../../creativeTemplatePage.slice';

interface RefetchParams {
  templateMeta: Record<string, DPMeta>;
  templateMapping: Record<string, DPLayerMapping[]>;
  currentState: CreativeTemplatePageState;
}

export default function refetchTemplateMappingData(
  dispatch: Dispatch,
  {templateMeta, templateMapping, currentState}: RefetchParams,
): void {
  const currentTemplateMeta = currentState.mapping.templateMeta || {};
  const currentTemplateMapping = currentState.mapping.originalMapping || {};

  // Build updated objects by merging with existing data
  const updatedTemplateMeta = {
    ...currentTemplateMeta,
    ...templateMeta,
  };

  const updatedTemplateMapping = {...currentTemplateMapping, ...templateMapping};

  // Set the updated data in Redux
  dispatch(setTemplateMeta(updatedTemplateMeta));
  dispatch(setTemplateMapping(updatedTemplateMapping));
  dispatch(setOriginalMapping(updatedTemplateMapping));
}
